function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import { BrandfolderHexColors } from "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
import { brandfolderColorPalette } from "./colors.js";
var textButtonBorderTransparent = {
  borderColor: 'transparent',
  borderColorActive: 'transparent',
  borderColorDisabled: 'transparent',
  borderColorFocus: 'transparent',
  borderColorHover: 'transparent'
};
var blackButton = _objectSpread({
  backgroundColor: 'transparent',
  backgroundColorActive: '#F9FBFC',
  backgroundColorDisabled: 'transparent',
  backgroundColorFocus: '#F1F5FA',
  backgroundColorHover: '#F1F5FA',
  outlineColorFocus: '#6f6f6f',
  textColor: BrandfolderHexColors.Text,
  textColorActive: '#9B9B9B',
  textColorFocus: '#6f6f6f',
  textColorHover: '#6f6f6f',
  textColorDisabled: '#BCBCBC'
}, textButtonBorderTransparent);
var dangerButton = {
  backgroundColor: BrandfolderHexColors.Delete,
  backgroundColorActive: '#000000',
  backgroundColorDisabled: '#F5F5F5',
  backgroundColorFocus: BrandfolderHexColors.Delete,
  backgroundColorHover: '#B30016',
  borderColor: BrandfolderHexColors.Delete,
  borderColorActive: '#000000',
  borderColorDisabled: '#F5F5F5',
  borderColorFocus: BrandfolderHexColors.Delete,
  borderColorHover: '#B30016',
  outlineColorFocus: BrandfolderHexColors.Delete,
  textColor: '#FFFFFF',
  textColorActive: '#FFFFFF',
  textColorFocus: '#FFFFFF',
  textColorHover: '#FFFFFF',
  textColorDisabled: '#BCBCBC'
};
var primaryButton = {
  backgroundColor: brandfolderColorPalette.primary[700],
  backgroundColorActive: brandfolderColorPalette.primary[900],
  backgroundColorDisabled: brandfolderColorPalette.neutrals[100],
  backgroundColorFocus: brandfolderColorPalette.primary[700],
  backgroundColorHover: brandfolderColorPalette.primary[800],
  borderColor: brandfolderColorPalette.primary[700],
  borderColorActive: brandfolderColorPalette.primary[900],
  borderColorDisabled: brandfolderColorPalette.neutrals[100],
  borderColorFocus: brandfolderColorPalette.primary[700],
  borderColorHover: brandfolderColorPalette.primary[800],
  outlineColorFocus: brandfolderColorPalette.primary[700],
  textColor: brandfolderColorPalette.neutrals[0],
  textColorActive: brandfolderColorPalette.neutrals[0],
  textColorFocus: brandfolderColorPalette.neutrals[0],
  textColorHover: brandfolderColorPalette.neutrals[0],
  textColorDisabled: brandfolderColorPalette.neutrals[400]
};
var secondaryButton = {
  backgroundColor: '#FFFFFF',
  backgroundColorActive: '#F1F5FA',
  backgroundColorDisabled: '#FFFFFF',
  backgroundColorFocus: '#FFFFFF',
  backgroundColorHover: '#F1F5FA',
  borderColor: '#4462C9',
  borderColorActive: '#4A4A4A',
  borderColorDisabled: '#BCBCBC',
  borderColorFocus: '#4462C9',
  borderColorHover: '#4462C9',
  outlineColorFocus: '#4462C9',
  textColor: '#4462C9',
  textColorActive: '#4A4A4A',
  textColorFocus: '#4462C9',
  textColorHover: '#4462C9',
  textColorDisabled: '#BCBCBC'
};
var tertiaryButton = {
  backgroundColor: '#FFFFFF',
  backgroundColorActive: '#F1F5FA',
  backgroundColorDisabled: '#FFFFFF',
  backgroundColorFocus: '#FFFFFF',
  backgroundColorHover: '#F1F5FA',
  borderColor: '#E2E2E2',
  borderColorActive: '#4A4A4A',
  borderColorDisabled: '#BCBCBC',
  borderColorFocus: '#9EAFE2',
  borderColorHover: '#4462C9',
  outlineColorFocus: '#4462C9',
  textColor: '#4A4A4A',
  textColorActive: '#4A4A4A',
  textColorFocus: '#4A4A4A',
  textColorHover: '#4462C9',
  textColorDisabled: '#BCBCBC'
};
var warningButton = {
  backgroundColor: '#FFFFFF',
  backgroundColorActive: '#000000',
  backgroundColorDisabled: '#F5F5F5',
  backgroundColorFocus: BrandfolderHexColors.Delete,
  backgroundColorHover: '#B30016',
  borderColor: BrandfolderHexColors.Delete,
  borderColorActive: '#000000',
  borderColorDisabled: '#F5F5F5',
  borderColorFocus: BrandfolderHexColors.Delete,
  borderColorHover: '#B30016',
  outlineColorFocus: BrandfolderHexColors.Delete,
  textColor: BrandfolderHexColors.Delete,
  textColorActive: '#FFFFFF',
  textColorFocus: '#FFFFFF',
  textColorHover: '#FFFFFF',
  textColorDisabled: '#BCBCBC'
};
var whiteButton = _objectSpread({
  backgroundColor: 'transparent',
  backgroundColorActive: 'transparent',
  backgroundColorDisabled: 'transparent',
  backgroundColorFocus: 'transparent',
  backgroundColorHover: 'transparent',
  outlineColorFocus: '#E6E6E6',
  textColor: '#fff',
  textColorActive: '#CBCBCB',
  textColorFocus: '#E6E6E6',
  textColorHover: '#E6E6E6',
  textColorDisabled: '#BCBCBC'
}, textButtonBorderTransparent);
var textSecondaryButton = _objectSpread(_objectSpread({}, secondaryButton), textButtonBorderTransparent);
var textTertiaryButton = _objectSpread(_objectSpread({}, tertiaryButton), textButtonBorderTransparent);
var textWarningButton = _objectSpread(_objectSpread({}, warningButton), textButtonBorderTransparent);
export { blackButton, dangerButton, primaryButton, secondaryButton, tertiaryButton, textSecondaryButton, textTertiaryButton, textWarningButton, warningButton, whiteButton };